import { GenericCrudPage } from '@/components/GenericCrudPage';
import { usersConfig } from '@/pages/configs';

export default function UsersPage() {
  return <GenericCrudPage config={usersConfig} />;
}
